import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppShell } from '@sage/ui';
import Sidebar from './components/Sidebar';
import SidebarFooter from './components/SidebarFooter';
import HomePage from './pages/HomePage';
import LibraryPage from './pages/LibraryPage';
import BasicEditorPage from './pages/BasicEditorPage';
import SettingsPage from './pages/SettingsPage';
import UpscalePage from './pages/UpscalePage';
import RemovePage from './pages/RemovePage';
import VariationsPage from './pages/VariationsPage';
import ExtendPage from './pages/ExtendPage';
import BackgroundPage from './pages/BackgroundPage';

const branding = { mark: 'M', name: 'MEDA', subtitle: 'Studio' };

export default function App() {
  return (
    <AppShell
      branding={branding}
      sidebar={<Sidebar />}
      sidebarFooter={<SidebarFooter />}
    >
      <div className="flex-1 overflow-y-auto">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/edit/:imageId" element={<BasicEditorPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/upscale" element={<UpscalePage />} />
          <Route path="/remove" element={<RemovePage />} />
          <Route path="/extend" element={<ExtendPage />} />
          <Route path="/variations" element={<VariationsPage />} />
          <Route path="/background" element={<BackgroundPage />} />
        </Routes>
      </div>
    </AppShell>
  );
}
